import React from "react";
import TypedDateInput from "./TypedDateInput";

// Custom input for CustomDatePicker: typed as MM/dd/yyyy and shown as
// Oct/10/2026 (TypedDateInput), or picked from the calendar opened on click.
// Only a complete date is handed over; a cleared field snaps back on blur.
const DateInput = React.forwardRef(
  (
    { value, onClick, onChange, onBlur, onFocus, onKeyDown, generateYears },
    ref,
  ) => (
    <TypedDateInput
      className="form-control p-2 w-100"
      onClick={(e) => {
        if (onClick) onClick(e);
        if (generateYears) {
          generateYears(value ? new Date(value).getFullYear() : undefined);
        }
      }}
      onChange={(e) => e.target.value && onChange(e)}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      value={value}
      ref={ref}
      required
    />
  ),
);

DateInput.displayName = "DateInput";

export default DateInput;
